export default __webpack_public_path__ + "static/media/pledge_2023.28bc2b13.gif";